module.exports = __webpack_public_path__ + "img/pacing-sidebar.663b82f5.svg";